import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import PropTypes from "prop-types";

import { DrilldownDataKeys } from "../../../helpers/reports.helper.types";
import {
  getTableData,
  isTableLoadFailed,
  isTableLoading,
} from "../../../store/reports/reducers/table/table.selectors";
import { Mobile, NotMobile } from "../../../hocs/Responsive";
import { DrilldownRoutePage } from "../drilldown.types";
import { DrilldownTableDesktop } from "./drilldownTable/DrilldownTableDesktop";
import { DrilldownTableMobile } from "./drilldownTable/DrilldownTableMobile";
import { useDrilldownData } from "./useDrilldownData";
import { getSelectedReportsProfile } from "../../../store/reports/reports.selectors";
import { getDrilldownReportsPeriod } from "../drilldown.selectors";
import { getSecureBlocksLimit } from "../../../store/config.selectors";
import { loadTableReports } from "../../../store/reports/reducers/table/table.actions";
import { chartProps } from "../drilldown.constants";

const getTableCount = (table) => {
  return _.reduce(
    table,
    (sum, item) => sum + _.sum(item.value.map((obj) => obj.count)),
    0
  );
};

export const DrilldownTable = ({ className, page }) => {
  const dataKey = DrilldownDataKeys[page];
  const dispatch = useDispatch();
  const table = useSelector(getTableData(dataKey), _.isEqual);
  const isLoading = useSelector(isTableLoading(dataKey));
  const isFailure = useSelector(isTableLoadFailed(dataKey));
  const profile = useSelector(getSelectedReportsProfile);
  const period = useSelector(getDrilldownReportsPeriod);
  const limit = useSelector(getSecureBlocksLimit);

  const fetchTableReports = useCallback(() => {
    const { tableDataEndpoint } = chartProps[page];

    dispatch(
      loadTableReports(tableDataEndpoint, {
        period,
        profile,
        ...(page !== DrilldownRoutePage.Botnet && { limit }),
      })
    );
  }, [dispatch, profile, period, limit, page]);

  useEffect(() => {
    fetchTableReports();
  }, [fetchTableReports]);

  const data = useDrilldownData(page, table);

  return (
    <div className={className}>
      <Mobile>
        <DrilldownTableMobile
          page={page}
          data={data}
          isLoading={isLoading}
          dataFailure={isFailure}
          onRefreshClick={fetchTableReports}
        />
      </Mobile>

      <NotMobile>
        <DrilldownTableDesktop
          page={page}
          tableCount={getTableCount(table)}
          data={data}
          isLoading={isLoading}
          dataFailure={isFailure}
          onRefreshClick={fetchTableReports}
        />
      </NotMobile>
    </div>
  );
};

DrilldownTable.propTypes = {
  page: PropTypes.oneOf([
    DrilldownRoutePage.Webfilter,
    DrilldownRoutePage.Malware,
    DrilldownRoutePage.Botnet,
  ]),
  className: PropTypes.string,
};
